<template>
  <v-container fluid grid-list-xl>
    <v-flex xs12 sm12 d-flex mt-1>
      <span class="az-subtitle primary--text">
        Membros da Comissão
      </span>
    </v-flex>

    <v-flex mt-2 mb-4>
      <comissao-dados-membros-novo v-if="editando" v-az-auth="'Comissao.Atualizar'"/>
    </v-flex>

    <v-flex xs12 sm12 d-flex>
      <v-data-table
          :headers="colunas"
          :items="value.comissaoUsuarios"
          class="az-table-list"
          :loading="false"
          hide-actions
          no-data-text="Nenhum membro de comissão encontrado"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.atribuicao }}</td>
          <td>{{ props.item.usuario.nome }}</td>
          <td v-if="exibirCamposAdicionais">{{ props.item.usuario.cpf | az-cpf-cnpj }}</td>
          <td v-if="exibirCamposAdicionais">{{ props.item.usuario.email }}</td>
          <td v-if="exibirCamposAdicionais">
            <v-text-field
                v-if="editandoUsuario && usuarioSelecionado.usuario.id === props.item.usuario.id"
                v-model="usuarioSelecionado.usuario.telefone"
                name="Telefone"
                style="min-width: 100px;"
                v-validate="{rules: {required:true,max:20}}"
                :error-messages="errors.collect('Telefone')" max-length="20"
            />
            <span v-else>{{ props.item.usuario.telefone | az-phone }}</span>
          </td>
          <td v-if="exibirCamposAdicionais">
            <v-text-field
                v-if="editandoUsuario && usuarioSelecionado.usuario.id === props.item.usuario.id"
                v-model="usuarioSelecionado.cargo"
                name="Cargo"
                style="min-width: 100px;"
                v-validate="'required'"
                :maxlength="20"
                :error-messages="errors.collect('Cargo')"
            />
            <span v-else>{{ props.item.cargo }}</span>
          </td>

          <td v-if="exibirCamposAdicionais">
            <v-autocomplete
                v-if="editandoUsuario && usuarioSelecionado.usuario.id === props.item.usuario.id"
                v-model="usuarioSelecionado.naturezaCargo"
                name="Natureza do Cargo"
                placeholder="Selecione"
                item-text="texto"
                item-value="valor"
                style="min-width: 140px;"
                :items="opcoesNaturezaCargo"
                v-validate="'required'"
                class="select-natureza-cargo"
                :error-messages="errors.collect('Natureza do Cargo')"
            />
            <span v-else>{{ getTexto(opcoesNaturezaCargo, props.item.naturezaCargo) }}</span>
          </td>

          <td v-if="exibirCamposAdicionais">
            <v-text-field
                v-if="editandoUsuario && usuarioSelecionado.usuario.id === props.item.usuario.id"
                v-model="usuarioSelecionado.descricaoNaturezaCargo"
                name="Descrição Natureza Cargo"
                style="min-width: 100px;"
                v-validate="usuarioSelecionado.naturezaCargo === 6 ? 'required' : ''"
                :error-messages="errors.collect('Descrição Natureza Cargo')"
            />
            <span v-else>{{ props.item.descricaoNaturezaCargo }}</span>
          </td>

          <td style="display: flex; padding: 0 10px; justify-content: center;" v-if="editando">
            <!-- CONFIRMAR -->
            <v-tooltip v-if="exibirCamposAdicionais && editandoUsuario && usuarioSelecionado.usuario.id === props.item.usuario.id" top class="no-mobile">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="alterarUsuarioComissao()">
                  <v-icon>check</v-icon>
                </v-btn>
              </template>
              <span>Confirmar</span>
            </v-tooltip>

            <!-- EDITAR -->
            <v-tooltip v-if="exibirCamposAdicionais && (!editandoUsuario || (editandoUsuario && usuarioSelecionado.usuario.id !== props.item.usuario.id))" top class="no-mobile">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="ativarModoEdicao(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <!-- REMOVER -->
            <v-tooltip top class="no-mobile">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="confirmarRemocaoMembro(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>

            <v-tooltip v-if="exibirCamposAdicionais && editandoUsuario && usuarioSelecionado.usuario.id === props.item.usuario.id" top class="no-mobile">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="desativarModoEdicao">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-flex>

    <!-- Confirmação de remoção -->
    <az-confirm
        @onConfirm="removerMembro"
        @onDecline="cancelarRemocao"
        v-if="mostrarDialog"
        :maxWidth="450"
    >
      Tem certeza que deseja desvincular o usuário da comissão?
    </az-confirm>
  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import ComissaoDadosMembrosNovo from './ComissaoDadosMembrosNovo'
import _ from "lodash";

export default {
  name: 'ComissaoDadosMembros',
  components: {ComissaoDadosMembrosNovo},
  props: {
    value: {required: true},
    editando: {type: Boolean, required: true}
  },
  data() {
    return {
      membroRemocao: null,
      mostrarDialog: false,
      editandoUsuario: false,
      usuarioSelecionado: null,
      opcoesNaturezaCargo: [
        {texto: 'Comissionado', valor: 5},
        {texto: 'Efetivo Civil', valor: 1},
        {texto: 'Efetivo Militar', valor: 2},
        {texto: 'Efetivo', valor: 3},
        {texto: 'Empregado Público', valor: 4},
        {texto: 'Outra', valor: 6}
      ]
    }
  },
  computed: {
    ...mapState(['parametros']),
    exibirCamposAdicionais() {
      return this.parametros.propriedadesLicitacao.exibirCamposAdicionaisComissao
    },
    colunas() {
      const colunasDefault = [
        {
          text: this.exibirCamposAdicionais ? 'Atribuição' : 'Função',
          align: 'left',
          sortable: false,
          width: '180px'
        },
        {
          text: this.exibirCamposAdicionais ? 'Nome' : 'Usuário',
          align: 'left',
          sortable: false
        }
      ]
      if (this.exibirCamposAdicionais) {
        colunasDefault.push(
            {text: 'CPF', align: 'left', sortable: false},
            {text: 'E-mail', align: 'left', sortable: false},
            {text: 'Telefone', align: 'left', sortable: false},
            {text: 'Cargo', align: 'left', sortable: false},
            {text: 'Natureza do Cargo', align: 'left', sortable: false}
        )
      }
      if (this.exibirCamposAdicionais) {
        colunasDefault.push({text: 'Descrição Natureza do Cargo', align: 'left', sortable: false})
      }
      if (this.editando) {
        colunasDefault.push({
          text: 'Ações',
          sortable: false,
          align: 'center',
          width: '50px'
        })
      }
      return colunasDefault
    }
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_COMISSAO_APURACAO,
      actionTypes.REMOVER_MEMBRO_COMISSAO,
      actionTypes.ATUALIZAR_USUARIO_COMISSAO
    ]),
    cancelarRemocao() {
      this.membroRemocao = null
      this.mostrarDialog = false
    },
    confirmarRemocaoMembro(comissaoUsuario) {
      this.membroRemocao = comissaoUsuario
      this.mostrarDialog = true
    },
    async alterarUsuarioComissao() {
      try {

        if(this.usuarioSelecionado.naturezaCargo === 6 && (!this.usuarioSelecionado.descricaoNaturezaCargo || this.usuarioSelecionado.descricaoNaturezaCargo.trim().length === 0)){
          this.mostrarNotificacaoErro('Informe a descrição da natureza do cargo!')
          return
        }

        const atualizarComissaoUsuarioInput = {
          comissaoConfiguracaoId: this.value.comissaoApuracao.id,
          usuarioId: this.usuarioSelecionado.usuario.id,
          atribuicao: this.usuarioSelecionado.atribuicao,
          cargo: this.usuarioSelecionado.cargo,
          naturezaCargo: this.usuarioSelecionado.naturezaCargo,
          descricaoNaturezaCargo: this.usuarioSelecionado.descricaoNaturezaCargo,
          telefone: this.usuarioSelecionado.usuario.telefone
        }

        console.log('Comissão atualizando', atualizarComissaoUsuarioInput)

        this.setMensagemLoading('Atualizando membro na comissão...')
        await this.atualizarUsuarioComissao({
          comissaoId: this.value.comissaoApuracao.id,
          atualizarComissaoUsuarioInput
        })
        this.desativarModoEdicao()
        await this.sincronizarComissao(this.value.comissaoApuracao.id)
        this.mostrarNotificacaoSucessoDefault()
      } catch (e) {
        console.error('Erro ao atualizar membro', e)
      }
    },
    async remover(usuarioRemocao) {
      this.setMensagemLoading('Removendo membro da comissão...')
      await this.removerMembroComissao(usuarioRemocao)
    },
    async removerMembro() {
      try {
        this.mostrarDialog = false
        const comissaoUsuario = this.membroRemocao
        const usuarioId = comissaoUsuario.usuario.id
        const comissaoApuracaoId =
            comissaoUsuario.comissaoUsuarioPK.comissaoConfiguracao.comissaoApuracao.id
        await this.remover({comissaoApuracaoId, usuarioId})
        await this.sincronizarComissao(comissaoApuracaoId)
        this.mostrarNotificacaoSucessoDefault()
      } catch (e) {
        this.cancelarRemocao()
      }
    },
    async sincronizarComissao(comissaoApuracaoId) {
      this.setMensagemLoading('Sincronizando comissão...')
      await this.buscarComissaoApuracao(comissaoApuracaoId)
    },
    getTexto(lista, valor) {
      if (valor) {
        return lista.find(item => item.valor === valor).texto
      }
    },
    ativarModoEdicao(item){
      this.usuarioSelecionado = _.cloneDeep(item)
      this.editandoUsuario = true
    },
    desativarModoEdicao(){
      this.editandoUsuario = false
      this.usuarioSelecionado = {
        usuario: { id: null, telefone: null},
        cargo: null,
        naturezaCargo: null,
        descricaoNaturezaCargo: null,
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.select-natureza-cargo
  margin-top 15px !important

.az-table-list
  tbody > tr > td
    padding 0 10px !important

.max-label
  display inline-block
  max-width 170px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

</style>
